export const GET_MOSQUE_REQUESTS_REQUEST = 'GET_MOSQUE_REQUESTS_REQUEST'
export const GET_MOSQUE_REQUESTS = 'GET_MOSQUE_REQUESTS'
export const GET_MOSQUE_REQUESTS_REQUEST_PENDING = 'GET_MOSQUE_REQUESTS_REQUEST_PENDING'
export const GET_MOSQUE_REQUESTS_REQUEST_SUCCESS = 'GET_MOSQUE_REQUESTS_REQUEST_SUCCESS'
export const GET_MOSQUE_REQUESTS_REQUEST_ERROR = 'GET_MOSQUE_REQUESTS_REQUEST_ERROR'
export const GET_MOSQUE_REQUEST_BY_ID_REQUEST = 'GET_MOSQUE_REQUEST_BY_ID_REQUEST'
export const GET_MOSQUE_REQUEST_BY_ID = 'GET_MOSQUE_REQUEST_BY_ID'

export const UPDATE_MOSQUE_REQUEST_STATUS_REQUEST = 'UPDATE_MOSQUE_REQUEST_STATUS_REQUEST'
export const UPDATE_MOSQUE_REQUEST_STATUS = 'UPDATE_MOSQUE_REQUEST_STATUS'
export const UPDATE_MOSQUE_REQUEST_STATUS_PENDING = 'UPDATE_MOSQUE_REQUEST_STATUS_PENDING'
export const UPDATE_MOSQUE_REQUEST_STATUS_SUCCESS = 'UPDATE_MOSQUE_REQUEST_STATUS_SUCCESS'
export const UPDATE_MOSQUE_REQUEST_STATUS_ERROR = 'UPDATE_MOSQUE_REQUEST_STATUS_ERROR'

